import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, timer } from 'rxjs';
import { navigate } from '@reach/router';
import { httpMethods, request } from '../../../../../services/http-service';
import { UPSERT_RATA } from '../../data.const';
import {
  retrieveRataListAction,
  setCurrentRataAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertRataEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_RATA),
    tap(p => console.log(`[epic ${UPSERT_RATA}]`, p)),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, ...rest } = payload?.body;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return { info: payload?.info, body: rest };
    }),
    tap(p => console.log(`[epic ${UPSERT_RATA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, info }, state]) => {
      return concat(
        of(setLoaders({ onorarioLoader: true, page: true })),
        defer(() =>
          from(request({ path: `rata`, method: httpMethods.POST, body })).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.result;
            }),
            switchMap(data =>
              concat(
                of(setCurrentRataAction(data)),
                of(null).pipe(
                  tap(() => {
                    if (body?.id) {
                      //
                    }
                    // navigate(
                    //   `${rootConfig.app_path}/account/onorari-edit/${
                    //     data?.id || 'crea'
                    //   }`
                    // ).then(() => null);
                  }),
                  delay(500),
                  switchMap(() =>
                    concat(
                      of(
                        setPopupInfo({
                          opened: true,
                          message: 'Operazione completata con successo',
                          timer: 3000,
                        })
                      ),
                      of(
                        retrieveRataListAction({
                          pageSize: rootConfig.pageSize,
                          page: 1,
                          order: [['descrizione', 'asc']],
                          filters: {
                            or: [
                              {
                                field: '$Onorario.id$',
                                value: info?.onorarioId,
                              },
                            ],
                          },
                        })
                      ),
                      of(null).pipe(
                        tap(() => {
                          info?.action && info?.action();
                        }),
                        switchMap(() => EMPTY)
                      )
                    )
                  )
                )
              )
            ),
            catchError(err => {
              console.error(`[epic ${UPSERT_RATA}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ onorarioLoader: false, page: false }))
      );
    })
  );

export default upsertRataEpic;
